export const mockPaymentPageData = {
  success: true,
  network: {
    ID: 35782,
    name: "St. Elizabeth on the Lake",
    city: "Austin",
    state: "TX",
    shortname: "mynet",
    website: "https://www.apple.com",
    iconURL: "//d6iyrqjd26xke.cloudfront.net/img95564/icon.jpg",
    isACHAllowed: true,
    isCardAllowed: true,
  },
  fund: {
    ID: 1318,
    description: "Youth Missions Fund",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    fundColor: "278DC1",
    createdBy: {
      name: "Randy Wilson",
      photoURL: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
    },
    paymentPageSettings: {
      suggestedAmounts: [30, 100, 250],
      paymentType: "donation", // "gift", "donation", "payment"
      hideConfetti: false,
    },
  },
  shoppingCart: {
    ID: 12345,
  },
  user: {
    ID: 11167815,
    loginLevel: "full", // "full", "partial", "none"
    name: "Chester Copperpot",
    photoURL: null,
    phoneNumber: 2082204905,
    email: "foster154@gmail.com",
    hasExistingPledge: false,
    sharableWith: ["John", "Suzy"], //other heads of households first names.  if a user has no first name, just put ""
    billingAddress: {
      addrLine1: null,
      addrLine2: null,
      city: null,
      state: "ID",
      zip: "76116",
    },
  },
  noteInfo: {
    // noteID: 1234,
    // noteUrl: "/note/1234567",
    // title:
    //   "We need your help! Please donate toward the youth group's Costa Rica Mission trip! We are collecting funds to help cover airfare, food, and lodging for 13 of our youths to travel and volunteer in an orphange for 2 weeks this July. Please consider giving, every little bit helps.",
    // author: {
    //   ID: 1234,
    //   name: "Margaret Thompson",
    //   photoURL: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
    // },
  },
  modifyPayment: {
    // paymentID: 93848,
    // paymentMethodID: 1234,
    // originalAmount: 1010, // in cents
    // paymentAlreadyCompleted: false,
    // paymentAlreadyCanceled: false,
  },
  paymentMethods: [
    {
      ID: 1234,
      paymentType: "card", // someday we'll have ACH, etc
      cardType: "discover", // mastercard, visa, amex, discover
      // nickname: "My favorite card", // null if empty
      nickname: null, // null if empty
      last4: "4532",
      expirationMonth: "04",
      expirationYear: "2023",
      hasOtherOwner: false,
      owner: {},
      isDefaultPaymentMethod: false,
      isEnabledForTTG: true,
      sharedWithOtherHoH: false,
      isAvailableAsSavedPaymentMethod: true,
    },
    {
      ID: 1235,
      accountHolderName: "",
      cardType: "checking",
      hasOtherOwner: false,
      isAvailableAsSavedPaymentMethod: true,
      isDefaultPaymentMethod: true,
      last4: "4242",
      mounted: true,
      nickname: "",
      owner: { ID: 2, fname: "Super", lname: "Admin", photo: null },
      paymentType: "bank",
      sharedWithOtherHoH: false,
    },
  ],
  paymentMethodProviders: [
    {
      paymentMethodCategory: "credit_card",
      paymentProvider: "stax",
      merchantToken: "Test-Merchant-23f1eba98b9f",
    },
    {
      paymentMethodCategory: "bank_account",
      provipaymentProviderder: "stax",
      merchantToken: "Test-Merchant-23f1eba98b9f",
    },
  ],
};
